var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.862 15.138a.667.667 0 0 1 0-.943l8.862-8.862H8A.667.667 0 0 1 8 4h7.333a.667.667 0 0 1 .667.667V12a.667.667 0 0 1-1.333 0V6.276l-8.862 8.862a.667.667 0 0 1-.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowTopRight;